(function () {
  'use strict';
  if (window.OTCDEbook) return;   /* asset included twice */

  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var active = null;              /* the live instance; replaced when the theme editor re-renders the section */

  function num(v, fallback) { var n = parseFloat(v); return isNaN(n) ? fallback : n; }

  function create(dialog) {
    var d = dialog.dataset;
    var cfg = {
      companyId: d.klaviyoCompany || '',
      listId: d.klaviyoList || '',
      revision: d.klaviyoRevision || '2026-01-15',
      eventName: d.klaviyoEvent || 'Requested E-book',
      source: d.klaviyoSource || 'E-book pop-up',
      ebookTitle: d.ebookTitle || '',
      ebookSlug: d.ebookSlug || 'ebook',
      pdfUrl: d.pdfUrl || '',
      emailDelivery: d.emailDelivery !== 'false',
      auto: d.auto !== 'false',
      delay: num(d.delay, 12),
      scroll: num(d.scroll, 50),
      exitIntent: d.exitIntent !== 'false',
      snoozeDays: num(d.snoozeDays, 14)
    };
    var STORAGE_KEY = 'otcd_ebook_' + cfg.ebookSlug;

    if (!cfg.companyId || !cfg.listId) {
      console.warn('[otcd-ebook] Missing data-klaviyo-company or data-klaviyo-list: submissions will fail.');
    }
    var pdfReady = !!cfg.pdfUrl && !/REPLACE-WITH/.test(cfg.pdfUrl);
    if (!pdfReady) {
      console.warn('[otcd-ebook] data-pdf-url is empty or still the placeholder. The pop-up will not open on its own until it is set.');
    }

    var views = {
      form: dialog.querySelector('[data-otcd-view="form"]'),
      done: dialog.querySelector('[data-otcd-view="done"]')
    };
    var form = dialog.querySelector('.otcd-ebook__form');
    var input = dialog.querySelector('.otcd-ebook__input');
    var honeypot = dialog.querySelector('.otcd-ebook__hp input');
    var submitBtn = form.querySelector('.otcd-ebook__submit');
    var msg = dialog.querySelector('.otcd-ebook__msg');
    var doneTitle = views.done.querySelector('.otcd-ebook__title');
    var formTitle = views.form.querySelector('.otcd-ebook__title');
    var openedBy = 'manual';
    var autoArmed = false;
    var sentThisVisit = false;   /* reopening after a send shows the sent view, not an empty form */
    var timer = null;
    var loadedAt = Date.now();

    /* ---------- frequency cap ---------- */
    function readState() {
      try { return JSON.parse(window.localStorage.getItem(STORAGE_KEY)) || {}; } catch (e) { return {}; }
    }
    function writeState(state) {
      try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (e) { /* storage blocked: cap lasts for this page only */ }
    }
    function eligible() {
      var s = readState();
      if (s.done) return false;
      if (s.shown && Date.now() - s.shown < cfg.snoozeDays * 864e5) return false;
      return true;
    }

    /* ---------- views ---------- */
    function showView(name) {
      views.form.hidden = name !== 'form';
      views.done.hidden = name !== 'done';
      dialog.setAttribute('aria-labelledby', (name === 'done' ? doneTitle : formTitle).id);
    }
    function setMessage(html) { msg.innerHTML = html || ''; }
    function setBusy(busy) {
      submitBtn.disabled = busy;
      submitBtn.setAttribute('aria-busy', busy ? 'true' : 'false');
      submitBtn.textContent = busy ? submitBtn.dataset.labelBusy : submitBtn.dataset.label;
    }
    function showError() {
      setMessage('That didn’t send. Check your connection and try again, or email <a href="mailto:info@otcyberdirect.com?subject=SMB%20OT%20security%20e-book">info@otcyberdirect.com</a> and we’ll send you the e-book.');
    }
    function showDone(email) {
      var mode = cfg.emailDelivery ? 'email-delivery' : 'download-only';
      Array.prototype.forEach.call(views.done.querySelectorAll('[data-otcd-if]'), function (el) {
        el.hidden = el.getAttribute('data-otcd-if') !== mode;
      });
      Array.prototype.forEach.call(views.done.querySelectorAll('[data-otcd-email]'), function (el) {
        el.textContent = email;
      });
      var dl = views.done.querySelector('[data-otcd-download]');
      /* Always show the download button; without a PDF URL (theme editor only) it points nowhere. */
      dl.href = cfg.pdfUrl || '#'; dl.hidden = false;
      showView('done');
      doneTitle.focus({ preventScroll: true });
    }

    /* ---------- open / close ---------- */
    function open(trigger) {
      if (dialog.open) return;
      openedBy = trigger || 'manual';
      /* Already signed up (this visit or an earlier one) and reopening by hand: go straight to the download */
      var returning = sentThisVisit || (openedBy === 'manual' && !!readState().done && !cfg.emailDelivery && pdfReady);
      if (returning) { if (!sentThisVisit) showDone(''); }
      else { showView('form'); setMessage(''); setBusy(false); input.removeAttribute('aria-invalid'); }
      dialog.showModal();
      /* Focus the heading, not the input: no surprise keyboard on phones */
      (returning ? doneTitle : formTitle).focus({ preventScroll: true });
      if (openedBy === 'timer' || openedBy === 'scroll' || openedBy === 'exit') {
        var s = readState(); s.shown = Date.now(); writeState(s);
      }
      disarm();
    }
    function close() { if (dialog.open) dialog.close(); }

    dialog.addEventListener('click', function (e) {
      if (e.target.closest('[data-otcd-ebook-close]')) { close(); return; }
      if (e.target === dialog) {   /* backdrop clicks land on the dialog element itself */
        var r = dialog.getBoundingClientRect();
        var inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
        if (!inside) close();
      }
    });

    /* ---------- Klaviyo ---------- */
    function klaviyoPost(resource, payload) {
      return fetch('https://a.klaviyo.com/client/' + resource + '?company_id=' + encodeURIComponent(cfg.companyId), {
        method: 'POST',
        headers: {
          'Accept': 'application/vnd.api+json',
          'Content-Type': 'application/vnd.api+json',
          'revision': cfg.revision
        },
        body: JSON.stringify(payload),
        keepalive: true
      }).then(function (res) {
        if (!res.ok) throw new Error('Klaviyo ' + resource + ' responded ' + res.status);
        return res;
      });
    }

    /* 1) Subscribe to the list with email marketing consent (the API default when no channels are named). */
    function subscribe(email) {
      return klaviyoPost('subscriptions', {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: cfg.source,
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: { list: { data: { type: 'list', id: cfg.listId } } }
        }
      });
    }

    /* 2) Record the request as an event. Nothing listens for it yet; a delivery flow can trigger from it later (ebook_url is there for that email's button). */
    function track(email) {
      return klaviyoPost('events', {
        data: {
          type: 'event',
          attributes: {
            properties: {
              ebook_title: cfg.ebookTitle,
              ebook_slug: cfg.ebookSlug,
              ebook_url: cfg.pdfUrl,
              trigger: openedBy,
              page_url: window.location.href,
              page_title: document.title
            },
            metric: { data: { type: 'metric', attributes: { name: cfg.eventName } } },
            profile: {
              data: {
                type: 'profile',
                attributes: { email: email, properties: { last_ebook_requested: cfg.ebookSlug } }
              }
            }
          }
        }
      });
    }

    function send(email) {
      if (dialog.dataset.dryRun === 'true' || designMode) {   /* harness and theme editor never create profiles */
        return new Promise(function (resolve) { window.setTimeout(resolve, 600); });
      }
      return subscribe(email).then(function () {
        /* The subscription is what the visitor asked for. An event failure is logged, not shown. */
        return track(email).catch(function (err) { console.warn('[otcd-ebook]', err); });
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (submitBtn.disabled) return;
      var email = (input.value || '').trim();

      if (honeypot && honeypot.value) { showDone(email); return; }   /* bot: pretend, send nothing */

      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
        input.setAttribute('aria-invalid', 'true');
        setMessage('Enter an email address like name@company.com.');
        input.focus();
        return;
      }
      input.removeAttribute('aria-invalid');
      setMessage('');
      setBusy(true);

      send(email).then(function () {
        var s = readState(); s.done = Date.now(); writeState(s);
        try { if (window.klaviyo && typeof window.klaviyo.identify === 'function') window.klaviyo.identify({ email: email }); } catch (err) { /* onsite tracking is optional */ }
        setBusy(false);
        sentThisVisit = true;
        showDone(email);
      }).catch(function (err) {
        console.warn('[otcd-ebook]', err);
        setBusy(false);
        showError();
      });
    });

    /* ---------- automatic triggers: delay, scroll depth, exit intent (first one wins) ---------- */
    function tryAuto(trigger) {
      if (!autoArmed || dialog.open) return;
      if (document.querySelector('dialog[open]')) return;              /* another modal (cart drawer, search) is up */
      var a = document.activeElement;
      if (a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName)) return;    /* visitor is typing: wait for the next trigger */
      open(trigger);
    }
    function onScroll() {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      if (max > 0 && (window.scrollY / max) * 100 >= cfg.scroll) tryAuto('scroll');
    }
    function onMouseOut(e) {
      if (!e.relatedTarget && e.clientY <= 0 && Date.now() - loadedAt > 4000) tryAuto('exit');
    }
    function arm() {
      if (autoArmed || !cfg.auto || designMode || !eligible()) return;
      if (!cfg.emailDelivery && !pdfReady) return;   /* download-only with no PDF link: nothing to hand over */
      autoArmed = true;
      if (cfg.delay > 0) timer = window.setTimeout(function () { tryAuto('timer'); }, cfg.delay * 1000);
      if (cfg.scroll > 0) window.addEventListener('scroll', onScroll, { passive: true });
      if (cfg.exitIntent && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        document.documentElement.addEventListener('mouseout', onMouseOut);
      }
    }
    function disarm() {
      autoArmed = false;
      window.clearTimeout(timer);
      window.removeEventListener('scroll', onScroll);
      document.documentElement.removeEventListener('mouseout', onMouseOut);
    }

    return {
      dialog: dialog,
      open: open,
      close: close,
      arm: arm,
      destroy: function () { disarm(); close(); },
      reset: function () { try { window.localStorage.removeItem(STORAGE_KEY); } catch (e) {} },
      preview: function (state) {
        sentThisVisit = false;
        close();
        open('preview');   /* not 'manual', so the returning-visitor shortcut is skipped */
        setBusy(false);
        if (state === 'done') { showDone('name@company.com'); return; }
        showView('form');
        if (state === 'error') { showError(); } else { setMessage(''); }
      }
    };
  }

  function boot(root) {
    var dialog = (root || document).querySelector('dialog.otcd-ebook');
    if (!dialog || typeof dialog.showModal !== 'function' || dialog.dataset.otcdReady) return;
    dialog.dataset.otcdReady = 'true';
    if (active) active.destroy();
    active = create(dialog);
    /* ?otcd_ebook=1 forces it open for QA, ignoring the frequency cap */
    if (/[?&]otcd_ebook=1\b/.test(window.location.search)) { active.open('manual'); } else { active.arm(); }
  }

  /* Any element with data-otcd-ebook-open (or a link to #otcd-ebook) opens it, ignoring the frequency cap */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-otcd-ebook-open], a[href="#otcd-ebook"]');
    if (!opener || !active) return;
    e.preventDefault();
    active.open('manual');
  });

  /* Theme editor: re-init when the section re-renders, and show the pop-up while its section is selected */
  if (designMode) {
    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
    document.addEventListener('shopify:section:select', function (e) { if (active && e.target.contains(active.dialog)) active.open('editor'); });
    document.addEventListener('shopify:section:deselect', function (e) { if (active && e.target.contains(active.dialog)) active.close(); });
  }

  /* Public hooks. preview(state) is for QA: 'form' | 'done' | 'error', sends nothing. */
  window.OTCDEbook = {
    open: function () { if (active) active.open('manual'); },
    close: function () { if (active) active.close(); },
    reset: function () { if (active) active.reset(); },
    preview: function (state) { if (active) active.preview(state); }
  };

  boot(document);
})();
